import { memo, useContext } from "react";

import classes from "./SearchWindow.module.css";

import SearchContext from "../../../store/search-context";

// component contains ingredients that shall be part of the search query
const SearchWindow = (props) => {
  const searchCtx = useContext(SearchContext);

  // remove item from the search window
  const removeFromSearchWindowHandler = (id) => {
    searchCtx.removeItem(id);
  };

  let searchWindowItems;

  searchWindowItems = props.items.map((item) => {
    return (
      <div
        key={item.id}
        className={classes.search_window_item}
        onClick={() => removeFromSearchWindowHandler(item.id)}
      >
        {item.title}
      </div>
    );
  });

  return <div className={classes.search_window}>{searchWindowItems}</div>;
};

export default memo(SearchWindow);
